import paidCoverImage from './paidCoverImage.png';
import unpaidCoverImage from './unpaidCoverImage.png';
import FeatureImageCurve from './featureImageCurve.png';
import ProfileMapPlaceholder from './profileMapPlaceholder.png';
import GalleryPlaceholder from './galleryPlaceholder.png';
import GalleryPlaceholderWebp from './galleryPlaceholder.webp';
import GalleryPlaceholderThumbnail from './galleryPlaceholderThumbnail.png';
import GalleryPlaceholderThumbnailWebp from './galleryPlaceholderThumbnail.webp';
import FeaturePlaceholderDesktop from './featurePlaceholderDesktop.png';
import FeaturePlaceholderDesktopWebp from './featurePlaceholderDesktop.webp';
import FeaturePlaceholderTablet from './featurePlaceholderTablet.png';
import FeaturePlaceholderTabletWebp from './featurePlaceholderTablet.webp';
import FeaturePlaceholderMobile from './featurePlaceholderMobile.png';
import FeaturePlaceholderMobileWebp from './featurePlaceholderMobile.webp';

export {
  unpaidCoverImage,
  paidCoverImage,
  FeatureImageCurve,
  ProfileMapPlaceholder,
  GalleryPlaceholder,
  GalleryPlaceholderWebp,
  GalleryPlaceholderThumbnail,
  GalleryPlaceholderThumbnailWebp,
  FeaturePlaceholderDesktop,
  FeaturePlaceholderDesktopWebp,
  FeaturePlaceholderTablet,
  FeaturePlaceholderTabletWebp,
  FeaturePlaceholderMobile,
  FeaturePlaceholderMobileWebp,
};
